import { render, staticRenderFns } from "./content1.vue?vue&type=template&id=66ba522d&scoped=true"
import script from "./content1.vue?vue&type=script&lang=js"
export * from "./content1.vue?vue&type=script&lang=js"
import style0 from "./content1.vue?vue&type=style&index=0&id=66ba522d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ba522d",
  null
  
)

export default component.exports